import React from 'react';
import { useSelector } from 'react-redux';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

// Types
import { Size } from 'Wpds/components/avatar/WpAvatar';

// Components
import WpAvatarGroup from 'Wpds/components/avatar/WpAvatarGroup';

type Props = {
  surfaceItem;
  size?: Size;
  limit?: number;
};

const SurfaceItemAvatars = ({ surfaceItem, size, limit = 6 }: Props) => {
  // If state.workspace is not set, we're most likely
  // looking at the surfaceAI table in another location
  // like the team page. Fall back on the All hands to get
  // user avatars from as a fail safe
  const { workspace: currentWorkspace } = useWorkspace();
  const teamSyncWorkspace = useSelector(state => state.workspaces.find(({ isTeamSync }) => isTeamSync));
  let users = [];

  // state.workspace redux is reset with empty objects
  // need to check and see if a name is set to confirm it's there
  if (currentWorkspace.name) {
    users = currentWorkspace.users;
  } else if (teamSyncWorkspace) {
    users = teamSyncWorkspace.users;
  }

  const usersFiltered = users.filter(({ id }) => surfaceItem.user_ids.includes(id));

  return <WpAvatarGroup size={size} users={usersFiltered} limit={limit} stacked showAdditionalCount />;
};

export default SurfaceItemAvatars;
